<template>
  <div>
    <div class="pa-1">
      <v-layout wrap row>
        <v-flex xs12>
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="series">
            <div class="font-weight-bold" pb-2>7 Days</div>
            <apexchart
              :key="barchartKey"
              type="bar"
              height="300"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </template>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import { DATETIME } from '@/constants/datetime.js'

export default {
  data() {
    return {
      barchartKey: new Date().getTime(),
      loading: false,
      data: [],
      series: [
        {
          name: '',
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: 300,
          type: 'bar'
        },
        labels: [],
        yaxis: {
          title: {
            text: 'Standard drink'
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val !== null ? `${val}%` : ''
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    await this.handleGetInitial()
  },
  methods: {
    async handleGetInitial() {
      const vm = this
      try {
        const response = await vm.getCurrentRetroactWithSubretroact()
        if (response) {
          let tempData = response.data[0] && response.data[0].subretroact
          let series = []
          let labels = []

          if (tempData) {
            tempData.forEach(function (item) {
              series.push(item.standard_drink)
              let tempDate = vm.handleGetDateFormatted(item.date)
              labels.push(tempDate)
            })
          }
          vm.series[0].data = series
          vm.chartOptions.labels = labels
          vm.barchartKey = new Date().getTime()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getCurrentRetroactWithSubretroact() {
      const vm = this
      let member_id = vm.$route && vm.$route.params.id
      let data = {
        page_id: vm.selectedBot.pageid,
        isdone: true
      }

      vm.loading = true
      const response = await nongtungjaiApi.getCurrentRetroactWithSubretroact(
        {
          config: {
            params: data
          }
        },
        member_id
      )

      vm.loading = false
      if (response && response.status === 200) {
        return response.data
      } else {
        return null
      }
    },
    handleGetDateFormatted(value) {
      return value ? moment(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/PatientChart.vue